var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table-cell-date",domProps:{"textContent":_vm._s(_vm.dateFormatted)}})}
var staticRenderFns = []

export { render, staticRenderFns }